import { format as dateFnsFormat, parseISO, differenceInDays, isAfter, isBefore } from 'date-fns';

/**
 * Format date to Australian format (dd/mm/yyyy)
 */
export const formatAUDate = (date) => {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  return dateFnsFormat(dateObj, 'dd/MM/yyyy');
};

/**
 * Format date with month name (e.g., "28 July 2024")
 */
export const formatLongDate = (date) => {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  return dateFnsFormat(dateObj, 'd MMMM yyyy');
};

/**
 * Calculate days until a deadline
 */
export const daysUntilDeadline = (deadlineDate) => {
  const deadline = typeof deadlineDate === 'string' ? parseISO(deadlineDate) : deadlineDate;
  return differenceInDays(deadline, new Date());
};

/**
 * Check if a deadline is overdue
 */
export const isOverdue = (deadlineDate) => {
  const deadline = typeof deadlineDate === 'string' ? parseISO(deadlineDate) : deadlineDate;
  return isBefore(deadline, new Date());
};

/**
 * Check if a deadline is due soon (within 7 days)
 */
export const isDueSoon = (deadlineDate) => {
  const deadline = typeof deadlineDate === 'string' ? parseISO(deadlineDate) : deadlineDate;
  const days = differenceInDays(deadline, new Date());
  return days >= 0 && days <= 7;
};
